import { useIsTradeInfoLoaded } from '~/context/srp/FinanceAndTradeContext';
import { useIsLoggedIn } from '~/context/srp/UserContext';

export default function useShouldFetchInventory() {
  const tradeIsLoaded = useIsTradeInfoLoaded();
  const isLoggedIn = useIsLoggedIn();

  return !isLoggedIn || tradeIsLoaded;
}
